// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BatteryIndicator_wrapper__3DTSI","batteryStatus":"BatteryIndicator_batteryStatus__31vPl"};